import {Component} from '@angular/core';
import {AbstractBackendStatusComponent} from '../abstract-backend-status.component';
import {IconComponent, LabelComponent} from '@icz/angular-essentials';
import {VersionInfoComponent} from '../../components/version-info/version-info.component';

@Component({
  templateUrl: './waiting-to-be.component.html',
  styleUrls: ['./waiting-to-be.component.scss'],
  imports: [IconComponent, LabelComponent, VersionInfoComponent]
})
export class WaitingToBeComponent extends AbstractBackendStatusComponent {}
